export default "__VITE_ASSET__CVJ6gq7M__"